import styled from "styled-components";

export const StyledPopinFormMarqueBlanche = styled.div`
  form {
    padding-top: 10px;
  }
  input {
    &.nom {
      text-transform: capitalize;
    }
  }
`;
